import Vue from 'vue';
import URI from "urijs";
import Sombra from 'JS/components/campaign/sombra/Sombra.vue';
import store from 'Stores/modules/campaign/store';
import WidgetHelper from "JS/helpers/widgetHelper";
import { AxiosLogCampaignClick } from "Api/public/axios";
import { cloneDeep as _cloneDeep } from 'lodash';

const widgetHelper = new WidgetHelper();

Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
});

const VM = new Vue({ // eslint-disable-line no-new
  el: '#p2a-campaign-container',
  store,
  components: {
    Sombra
  },
  data() {
    const {
      campaign: appSettings,
      campaignSettings,
      customerSettings,
      customFieldsValues,
    } = _cloneDeep(window.P2A);

    return {
      appSettings,
      campaignSettings,
      customerSettings,
      customFieldsValues,
      isWidget: widgetHelper.isWidget(appSettings),
    };
  },
  created() {
    this.logCampaignClick();
  },
  methods: {
    async logCampaignClick() {
      if (this.campaignSettings.cacheable) {
        const { shortUrl, p2aSourceId } = this.appSettings;
        const uri = new URI(window.location.href.toString());

        /* eslint-disable camelcase */
        const {
          utm_source,
          utm_medium,
          utm_campaign,
          utm_term,
          utm_content
        } = uri.search(true);
        /* eslint-enable camelcase */

        const response = await AxiosLogCampaignClick.post("", {
          shortUrl,
          p2aSourceId,
          userAgent: navigator.userAgent,
          referer: document.referrer,
          utm_source,
          utm_medium,
          utm_campaign,
          utm_term,
          utm_content
        });

        const { loadStart } = response.data;

        this.appSettings.loadStart = loadStart;
      }
    }
  }
});
